(() => {
  const reviewTargets = [
    '.jdgm-rev-snippet-widget-v2',
    '.jdgm-rev-snippet-widget-v2__inner',
    '.jdgm-rev-snippet-card',
    '#judgeme_product_reviews',
    '.jdgm-review-widget',
    '.jdgm-rev-widg',
    '[data-judge-me-review-widget]',
    '.spr-container'
  ];

  const getReviewTarget = () => reviewTargets
    .map((selector) => document.querySelector(selector))
    .find((element) => element !== null);

  document.addEventListener('click', (event) => {
    const reviewTrigger = event.target.closest('.jdgm-preview-badge, .jdgm-prev-badge');

    if (!reviewTrigger) return;

    const target = getReviewTarget();
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });

    if (target.id && window.history.replaceState) {
      window.history.replaceState(null, '', `#${target.id}`);
    }
  });
})();

/*
 * Ürün videosu modal'ı (hp-product-video snippet'i) — açılınca videoyu
 * oynat, kapanınca durdur. x-modal açılıp kapandığında "toggle" event'ini
 * bubbles: true ile yayınlıyor; tema modal kapanınca medyayı kendisi
 * durdurmuyor.
 */
document.addEventListener('toggle', (event) => {
  const modal = event.target;
  if (!(modal instanceof HTMLElement) || !modal.classList.contains('hp-product-video__modal')) return;

  const video = modal.querySelector('video');
  if (!video) return;

  if (modal.hasAttribute('open')) {
    video.play().catch(() => {});
  } else {
    video.pause();
  }
});
